import styled from "styled-components";

export const Dot = styled.span<{ color?: string; size?: number }>`
  height: ${(props) => props.size || 12}px;
  width: ${(props) => props.size || 12}px;
  background-color: ${(props) => props.color || "#38a169"};
  border-radius: 50%;
  display: inline-block;
`;
